import { Controller, useFormContext } from 'react-hook-form'

import { Component } from './Component'

import type { CheckboxProps } from './types'

export const Checkbox = ({ name, label, checked, onChange, hasController = true, ...rest }: CheckboxProps) => {
  if (hasController) {
    const { control } = useFormContext()

    return (
      <Controller
        name={name}
        control={control}
        render={({ field }) => (
          <Component
            name={name}
            label={label}
            checked={field.value}
            onChange={field.onChange}
            onBlur={field.onBlur}
            {...rest}
          />
        )}
      />
    )
  }

  return <Component name={name} label={label} checked={checked} onChange={onChange} {...rest} />
}
